import { useCallback } from "react";

import { AllowedValuesDTO } from "api";

import { QUERY_PARAMS_KEYS } from "consts";

import { sortBy } from "utils";

import { useSingeSelectWithFetch } from "./singleselect";

import { useGetAllowedValues } from "../api";
import { OptionalMultiselectProps } from "../multiselect/types";

export const useFacilityTypesSelect = ({
  updateExternalStates,
  getQueryParamsWithExternalChanges,
  withQueryParams = true,
  withEmptyOption = false,
}: OptionalMultiselectProps = {}) => {
  const getOptionsFromData = useCallback(
    (allowedValues?: AllowedValuesDTO) => {
      const facilityTypesAscOrder = sortBy({
        array: (allowedValues || { siteTypes: [] }).siteTypes,
      });

      if (withEmptyOption) {
        facilityTypesAscOrder.push("");
      }
      return facilityTypesAscOrder;
    },
    [withEmptyOption],
  );

  const {
    isLoading: isFacilityTypesLoading,
    setSelectedOption: setSelectedFalityTypeOption,
    selectedOption: selectedFacilityType,
    options: facilityTypesList,
    selectedOptionValues: facilityType,
  } = useSingeSelectWithFetch({
    updateExternalStates,
    getQueryParamsWithExternalChanges,
    withQueryParams,
    useGetData: useGetAllowedValues,
    getOptionsFromData,
    queryKey: QUERY_PARAMS_KEYS.SITE_TYPES,
  });

  return {
    isFacilityTypesLoading,
    setSelectedFalityTypeOption,
    selectedFacilityType,
    facilityTypesList,
    facilityType,
  };
};
